import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, PropType, computed } from "vue";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.scss";
import {
  ICampaign,
  ICampaignImage,
} from "@/domain/entities/serviceInfo/serviceInfo.types";
import CampaignDetailSwiper from "./CampaignDetailSwiper.vue";
import { CampaignImageType, CampaignImageTypeCode } from "@/types";
import InlineSvg from "vue-inline-svg";
import "core-js/features/array/flat-map";
import PageModal from "../shared/modal/base/PageModal.vue";


const __default__ = {
  name: "CampaignBannerSwiper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  campaigns: {
    type: Array as PropType<ICampaign[]>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const getCampaignImagesByType = (
  campaigns: ICampaign[],
  type: CampaignImageType
) => {
  return campaigns
    .flatMap((campaign) => campaign.images)
    .filter((image) => image.imageTypeCode === type);
};

const campaignBannerImages = getCampaignImagesByType(
  props.campaigns ?? [],
  CampaignImageTypeCode.BANNER
);

const hasMutlipleBanners = computed(() => campaignBannerImages.length > 1);

const getCampaignTitle = (index: number) => {
  return props.campaigns[index]?.name ?? "캠페인";
};

const playButtonLabel = computed(() =>
  isPlaying.value ? "배너 슬라이드 일시정지" : "배너 슬라이드 재생"
);

const campaignCardNewsImages = ref<ICampaignImage[]>([]);
const updateCampaignCardNewsImages = (images: ICampaignImage[]) => {
  campaignCardNewsImages.value = images;
};

const selectedCampaign = ref<ICampaign>();

const swiperInstance = ref();
const onSwiper = async (swiper: SwiperCore) => {
  swiperInstance.value = swiper;
};

const autoplayOptions = {
  delay: 5000,
  disableOnInteraction: false,
  pauseOnMouseEnter: true,
};

const isPlaying = ref(true);
const currentIndex = ref(0);

const toggleAutoplay = (): void => {
  if (!swiperInstance.value) return;

  if (isPlaying.value) {
    swiperInstance.value.autoplay.stop();
  } else {
    swiperInstance.value.autoplay.start();
  }
  isPlaying.value = !isPlaying.value;
};

const onSlideChange = (swiper: SwiperCore): void => {
  if (!swiper) return;
  currentIndex.value = swiper.realIndex;
};

const goToSlide = (index: number): void => {
  if (!swiperInstance.value) return;
  swiperInstance.value.slideTo(index);
};

const onClickCampaignBannerImage = (index: number) => {
  selectedCampaign.value = props.campaigns[index];
  const cardNewsImages = props.campaigns[index]?.images.filter(
    (img) => img.imageTypeCode === CampaignImageTypeCode.CARD_NEWS
  );
  updateCampaignCardNewsImages(cardNewsImages ?? []);
  toggleShowCampaignDetailSwiper(true);
};

const shouldShowCampaignDetailSwiper = ref(false);
const toggleShowCampaignDetailSwiper = (show: boolean) => {
  if (!campaignCardNewsImages.value.length) return;

  shouldShowCampaignDetailSwiper.value = show;

  if (!show) {
    selectedCampaign.value = undefined;
    updateCampaignCardNewsImages([]);
  }
};

// 배너 아이콘 컬러
const bannerIconColor = computed(() => {
  const targetBanner = props.campaigns[currentIndex.value];
  if (!targetBanner) return "#FFFFFF";

  return targetBanner.bannerIconColor;
});

onMounted(() => {});

const __returned__ = { props, getCampaignImagesByType, campaignBannerImages, hasMutlipleBanners, getCampaignTitle, playButtonLabel, campaignCardNewsImages, updateCampaignCardNewsImages, selectedCampaign, swiperInstance, onSwiper, autoplayOptions, isPlaying, currentIndex, toggleAutoplay, onSlideChange, goToSlide, onClickCampaignBannerImage, shouldShowCampaignDetailSwiper, toggleShowCampaignDetailSwiper, bannerIconColor, get Autoplay() { return Autoplay }, get Swiper() { return Swiper }, get SwiperSlide() { return SwiperSlide }, CampaignDetailSwiper, get InlineSvg() { return InlineSvg }, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})